















































































import Vue from 'vue';
import InfoDialog from '@/components/info/InfoDialog.vue';
import { orgRoleColors } from '../utils/unrulrColors';

export default Vue.extend({
  components: {
    InfoDialog
  },

  data() {
    return {
      adminColors: orgRoleColors.admin,
      organizerColors: orgRoleColors.organizer,
      memberColors: orgRoleColors.member
    };
  }
});
